import { motion } from "framer-motion";
import { Reveal, Overline } from "./Reveal";
import { STEPS } from "../lib/content";

export const HowItWorks = ({ onConsult }) => (
  <section id="process" className="relative bg-[#1a1410] py-24 sm:py-36 scroll-mt-20">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="max-w-3xl">
        <Reveal>
          <Overline>How It Works</Overline>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 font-serif font-bold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.05]">
            A Clear Path to <span className="text-gold-foil">Success</span>
          </h2>
        </Reveal>
      </div>

      <div className="mt-16 grid lg:grid-cols-3 gap-8 lg:gap-6 relative">
        <div className="hidden lg:block absolute top-10 left-[16%] right-[16%] h-px border-t border-dashed border-amber-500/25" />
        {STEPS.map((s, i) => (
          <motion.div
            key={s.step}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.15, ease: [0.16, 1, 0.3, 1] }}
            className="relative"
          >
            <div className="relative z-10 flex h-20 w-20 items-center justify-center rounded-full bg-[#262019] border border-amber-500/40 mb-8">
              <span className="font-serif text-3xl font-bold text-gold-foil">
                {i + 1}
              </span>
            </div>
            <p className="text-xs uppercase tracking-[0.2em] text-amber-500">
              {s.step}
            </p>
            <h3 className="mt-3 font-serif text-2xl sm:text-3xl text-white">
              {s.title}
            </h3>
            <p className="mt-4 text-zinc-400 font-light leading-relaxed max-w-sm">
              {s.desc}
            </p>
          </motion.div>
        ))}
      </div>

      <Reveal delay={0.1}>
        <div className="mt-16">
          <button
            onClick={onConsult}
            data-testid="process-cta-btn"
            className="bg-gold-foil text-black text-[13px] font-bold tracking-[0.14em] uppercase px-8 py-4 hover:brightness-110 transition-all duration-300"
          >
            Start Step 1 — Book Your Free 15-Minute Consultation
          </button>
        </div>
      </Reveal>
    </div>
  </section>
);
